import { useState, useEffect } from 'react';
import useDebounce from 'FormsUI/utils/useDebounce';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { SEARCH_PROPERTIES } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertiesSearchInput = ({
  placeholder,
  handleQueryChange
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearchTerm = useDebounce(searchQuery, 500);
  useEffect(() => {
    trackEditorInteraction(SEARCH_PROPERTIES);
    handleQueryChange(searchQuery);
  },
  // eslint-disable-next-line
  [debouncedSearchTerm]);
  const handleSearchChange = ({
    target: {
      value = ''
    }
  }) => setSearchQuery(value);
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": "search properties",
    margin: "300",
    marginBlockEnd: "0",
    children: /*#__PURE__*/_jsx(SearchInput, {
      value: searchQuery,
      placeholder: placeholder,
      "data-test-id": "properties-search",
      "data-onboarding": "properties-search-input",
      onChange: handleSearchChange
    })
  });
};
export default PropertiesSearchInput;